import { get_DefaultStringArrayFormatk3qh72vmys6l as get_DefaultStringArrayFormat } from '../../serialization/urlify.mjs';
import {
  HttpMethod_GET_getInstance2m1rvu4d8a2j3 as HttpMethod_GET_getInstance,
  HttpMethod_POST_getInstance3c6ouf174z7cx as HttpMethod_POST_getInstance,
  HttpMethod_PATCH_getInstance2444xhczsg6ri as HttpMethod_PATCH_getInstance,
  HttpMethod_DELETE_getInstance1ayy9xx1uf6c9 as HttpMethod_DELETE_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/fetch.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  serializer1cdzkc3mnhoc4 as serializer,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  serializer1hu9wv9at41ww as serializer_0,
  serializer1wpgysz06u9ol as serializer_1,
  get_nullable197rfua9r7fsz as get_nullable,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { Companion_getInstance23ulzawec7mjy as Companion_getInstance } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/ModelPermissions.mjs';
import { Companion_getInstance1p5xjdbhmj22t as Companion_getInstance_0 } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { Companion_getInstance15uq20f985jxw as Companion_getInstance_1 } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/MassModification.mjs';
import {
  IntCompanionObject_instance3tw56cgyd5vup as IntCompanionObject_instance,
  DoubleCompanionObject_instance3q51gr7gsd0au as DoubleCompanionObject_instance,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { Companion_instance30d6g5ap8rdfm as Companion_instance } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/Modification.mjs';
import { Companion_instancek13g6rikuawd as Companion_instance_0 } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { Companion_getInstance2me4dixbj0lj0 as Companion_getInstance_2 } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/GroupCountQuery.mjs';
import { ClientModelRestEndpointsuzria74ft4w4 as ClientModelRestEndpoints } from './ClientModelRestEndpoints.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstance8oiu9odho220 as Companion_getInstance_3 } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/CollectionUpdates.mjs';
import { ClientModelRestEndpointsPlusUpdatesWebsocket34r6fusayskwn as ClientModelRestEndpointsPlusUpdatesWebsocket } from './deprecated.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function urlifyToCommaString($this, _this__u8e3s4) {
  return get_DefaultStringArrayFormat().x27($this.jek_1, _this__u8e3s4);
}
var ClientModelRestEndpointsLiveClass;
function ClientModelRestEndpointsLive() {
  if (ClientModelRestEndpointsLiveClass === VOID) {
    class $ {
      constructor(fetcher, subpath, serializer, idSerializer) {
        this.gek_1 = fetcher;
        this.hek_1 = subpath;
        this.iek_1 = serializer;
        this.jek_1 = idSerializer;
      }
      kek($completion) {
        return this.gek_1.fei(this.hek_1 + '/_permissions_', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance().s2j(this.iek_1), $completion);
      }
      aek(input, $completion) {
        return this.gek_1.fei(this.hek_1 + '/query', HttpMethod_POST_getInstance(), Companion_getInstance_0().d2j(this.iek_1), input, ListSerializer(this.iek_1), $completion);
      }
      bek(input, $completion) {
        return this.gek_1.fei(this.hek_1 + '/bulk', HttpMethod_POST_getInstance(), ListSerializer(this.iek_1), input, ListSerializer(this.iek_1), $completion);
      }
      cek(input, $completion) {
        return this.gek_1.fei(this.hek_1, HttpMethod_POST_getInstance(), this.iek_1, input, this.iek_1, $completion);
      }
      dek(input, $completion) {
        return this.gek_1.fei(this.hek_1 + '/bulk', HttpMethod_PATCH_getInstance(), Companion_getInstance_1().d2j(this.iek_1), input, serializer_0(IntCompanionObject_instance), $completion);
      }
      eek(id, input, $completion) {
        return this.gek_1.fei(this.hek_1 + '/' + urlifyToCommaString(this, id), HttpMethod_PATCH_getInstance(), Companion_instance.d2j(this.iek_1), input, this.iek_1, $completion);
      }
      fek(id, $completion) {
        return this.gek_1.fei(this.hek_1 + '/' + urlifyToCommaString(this, id), HttpMethod_DELETE_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      lek(input, $completion) {
        return this.gek_1.fei(this.hek_1 + '/count', HttpMethod_POST_getInstance(), Companion_instance_0.d2j(this.iek_1), input, serializer_0(IntCompanionObject_instance), $completion);
      }
      mek(input, $completion) {
        return this.gek_1.fei(this.hek_1 + '/aggregate', HttpMethod_POST_getInstance(), Companion_getInstance_2().s2j(this.iek_1), input, get_nullable(serializer_1(DoubleCompanionObject_instance)), $completion);
      }
    }
    initMetadataForClass($, 'ClientModelRestEndpointsLive', VOID, VOID, [ClientModelRestEndpoints()], [0, 1, 2]);
    ClientModelRestEndpointsLiveClass = $;
  }
  return ClientModelRestEndpointsLiveClass;
}
var ClientModelRestEndpointsPlusUpdatesWebsocketLiveClass;
function ClientModelRestEndpointsPlusUpdatesWebsocketLive() {
  if (ClientModelRestEndpointsPlusUpdatesWebsocketLiveClass === VOID) {
    class $ {
      constructor(fetcher, subpath, serializer, idSerializer) {
        this.nek_1 = fetcher;
        this.oek_1 = subpath;
        this.pek_1 = serializer;
        this.qek_1 = idSerializer;
      }
      rek() {
        return this.nek_1.sek(this.oek_1, Companion_instance_0.d2j(this.pek_1), Companion_getInstance_3().t3l(this.pek_1, this.qek_1));
      }
    }
    initMetadataForClass($, 'ClientModelRestEndpointsPlusUpdatesWebsocketLive', VOID, VOID, [ClientModelRestEndpointsPlusUpdatesWebsocket()]);
    ClientModelRestEndpointsPlusUpdatesWebsocketLiveClass = $;
  }
  return ClientModelRestEndpointsPlusUpdatesWebsocketLiveClass;
}
//region block: exports
export {
  ClientModelRestEndpointsLive as ClientModelRestEndpointsLive3jcski6s83sw3,
  ClientModelRestEndpointsPlusUpdatesWebsocketLive as ClientModelRestEndpointsPlusUpdatesWebsocketLivefh363mjnrhnn,
};
//endregion

//# sourceMappingURL=ClientModelRestEndpointsLive.mjs.map
